import React from "react";

import InfoTooltipButton from "./InfoTooltipButton";

const formatMultiple = (value) =>
  `${Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}x`;

const ImpactSummaryRow = ({ metrics }) => {
  const items = [
    {
      key: "roi",
      title: "Return on investment",
      value: formatMultiple(metrics.estimated_roi),
      tooltip:
        "An estimate of this event's return on investment. For upcoming events, these numbers typically grow significantly in the final days before the event and are often low in the weeks leading up to it. We calculate ROI by adding estimated ticket sales revenue plus the monetary value of time saved (at $15/hour), then dividing by total marketing spend on this event.",
    },
    {
      key: "roas",
      title: "Return on ad spend",
      value: formatMultiple(metrics.roas),
      tooltip:
        "An estimate of this event's return on ad spend. For upcoming events, these numbers typically grow significantly in the final days before the event and are often low in the weeks leading up to it. We calculate ROAS by dividing estimated ticket sales revenue by total ad spend on this event.",
    },
  ];

  return (
    <div className="event-analytics-preview__impact-grid">
      {items.map((item) => (
        <article
          className={`event-analytics-preview__impact-card event-analytics-preview__impact-card--${item.key}`}
          key={item.key}
        >
          <div className="event-analytics-preview__impact-card-top">
            <p className="event-analytics-preview__impact-label">{item.title}</p>

            <div className="event-analytics-preview__impact-value-row">
              <p className="event-analytics-preview__impact-value">{item.value}</p>
              <InfoTooltipButton content={item.tooltip} label={`${item.title} explanation`} />
            </div>
          </div>
        </article>
      ))}
    </div>
  );
};

export default ImpactSummaryRow;
